import { IntakeLabelCollection } from '../../entities/intake-label.interface';

export const IesSignaturesLabels: IntakeLabelCollection = {};
